/*
 * @Author: bbqin
 * @Date: 2022-01-11 14:45:55
 * @LastEditTime: 2022-01-12 14:15:18
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\CardContainer\compatible.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React from "react";
import CardContainer from "./index";

/**
 * 判断是否存在store
 * @param {*} moduleId 
 * @returns 
 */
function getStore(moduleId) {
    if (this.cardContainerDataSource && this.cardContainerDataSource[moduleId]) {
        return this.cardContainerDataSource[moduleId];
    } else {
        // console.warn('不存在cardContainerDataSource');
        // return null
        // 暂时通过error 提醒业务组、 稳定后可去掉
        throw Error(`正在调用ID为${moduleId}的卡片容器的API, 但此卡片容器还未通过use.cardContainer注册,请先注册此ID，才能正常调用API`);
    }
}

/**
 * 创建卡片容器
 * @param {*} id 
 * @param {*} config 
 */
function createCardContainer(id, config) {
    let currentStore = getStore.call(this, id);
    return <CardContainer
        {...config}
        id={id}
        store={currentStore}
    />;
}

// 设置数据
function setData(id, data, shouldForceUpdate) {
    let currentStore = getStore.call(this, id);
    currentStore.setData({ data, shouldForceUpdate });
}

// 获取数据
function getData(id, data) {
    let currentStore = getStore.call(this, id);
    return currentStore.getData(data);
}

// 设置某项
function setItems(id, items, shouldForceUpdate) {
    let currentStore = getStore.call(this, id);
    currentStore.setItems(id, items, shouldForceUpdate);
}

// 获取某项
function getItems(id, keys) {
    let currentStore = getStore.call(this, id);
    return currentStore.getItems(id, keys);
}

// 隐藏区域
function setVisible(id, value, shouldForceUpdate) {
    let currentStore = getStore.call(this, id);
    currentStore.setStore('visible', value, shouldForceUpdate);
}

export { createCardContainer, setData, getData, setItems, getItems, setVisible };